import {Component, effect, inject, NgZone, untracked} from '@angular/core';
import {ChildrenOutletContexts, Router, RouterModule} from '@angular/router';
import { slideInAnimation } from 'src/shared/animations/animations';
import { LogoutComponent } from '@app-logout/feature/logout.component';
import { TourComponent } from '@shared/components/tour/tour.component';
import { AuthStore } from '@app-auth/data-access/auth.store';
import { PushNotificationsStore } from '@shared/stores/push-notifications.store';
import { IClientDevice } from '@app-auth/data-access/entities/auth.interface';
import { App, URLOpenListenerEvent } from '@capacitor/app';


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: true,
  // Sem IonicModule: o template daqui nao usa nenhum elemento ion-*, e o import
  // trazia os proxies dos 112 componentes do Ionic para o bundle inicial. As telas
  // que usam Ionic continuam importando o modulo por conta propria, so que agora
  // dentro dos chunks lazy delas. O IonicModule.forRoot() do main.ts, que registra
  // config e plataforma, e independente disso e continua no lugar.
  imports: [RouterModule, LogoutComponent, TourComponent],
  animations: [slideInAnimation],
})
export class AppComponent {
  public authStore = inject(AuthStore);
  public pushNotificationsStore = inject(PushNotificationsStore);
  private zone = inject(NgZone);
  private router = inject(Router);
  protected onDeviceInfoChange = effect(() => {
    const token = this.pushNotificationsStore?.Token();
    const authData = this.authStore?.AuthData();

    if (this.authStore.deviceInfoLoaded() && token && !this.authStore.refreshClientDeviceLoaded()) {
      untracked(() => {
        const deviceInfo = this.authStore.DeviceInfo();

        if (token && token.value) {
          const data: IClientDevice = {
            FcmToken: token.value,
            PersonId: authData?.PersonId,
            TenantId: authData?.TenantId,
            Manufacturer: deviceInfo?.manufacturer,
            Model: deviceInfo?.model,
            Platform: deviceInfo?.platform,
            Serial: null,
            UuId: deviceInfo?.Uuid,
            Version: deviceInfo?.webViewVersion,
          };

          this.authStore.refreshClientDevice(data);
        }
      });
    }
  });

  constructor(private contexts: ChildrenOutletContexts) {

    App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      this.zone.run(() => {
        // Example url: https://beta.trei.no/common/login/.....
        // slug = /common/login/.....

        this.router.navigateByUrl('/').then(r => {
        });

        // If no match, do nothing - let regular routing
      });
    });
  }


  getRouteAnimationData() {
    return this.contexts.getContext('primary')?.route?.snapshot?.data?.['animation'];
  }
}
